module.exports = __webpack_public_path__ + "img/Logo_nuevo_horizontal.e45bb223.png";